// extracted by mini-css-extract-plugin
export var locationCard = "_qa-0";